import { TableCell } from "@amzn/meridian/table";
import React from "react";
import { ITableRowProps } from "./definitions";
import Link from "@amzn/meridian/link";
import { downloadBlob, formatStatus, getCurrencyFormat, getTableCells } from "./utils";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { useSheets } from "../../features/sheets/hooks";
import { formatDateTime } from "../../features/time/Time";
import { EditDocumentModal } from "../edit-document-modal/EditDocumentModal";
import { formatLongString } from "../../utils/formattingUtils";
import { Storage } from "aws-amplify";

export const TableRows: React.FC<ITableRowProps> = ({
    data,
    currentRow,
    currentTable,
    headers,
}) => {
    const { setOpenSheets, updateSheets } = useSheets();
    const navigate = useNavigate();
    const headerCells = headers;
    const currentRowData = data.at(currentRow);
    const currentRowDataMap = new Map(Object.entries(currentRowData));
    const tableCells = getTableCells(headerCells, currentRowDataMap, currentTable);

    const handleTableNavigation = (id, cell) => {
        if (currentTable == "parcel" || currentTable == "property") {
            navigate(cell.link);
        }

        if (id === "mailId") {
            updateSheets(
                <>
                    <EditDocumentModal data={data} currentRow={currentRow} />
                </>
            );
            setOpenSheets(true);
        }
    };

    return (
        <React.Fragment>
            {tableCells.map(cell => {
                switch (cell?.type) {
                    case "LINK": {
                        return (
                            <TableCell key={_.uniqueId(cell.id)} width={"fit"}>
                                {cell?.link.trim() ? (
                                    <Link
                                        onClick={() => {
                                            cell.id === "mailId"
                                                ? handleTableNavigation(cell.id, cell)
                                                : navigate(cell.link);
                                        }}
                                        type="secondary"
                                        href={cell.id === "mailId" ? undefined : cell.link}
                                    >
                                        {formatLongString(cell?.value)}
                                    </Link>
                                ) : (
                                    cell?.value
                                )}
                            </TableCell>
                        );
                    }
                    case "DATE": {
                        return (
                            <TableCell key={_.uniqueId(cell.id)}>
                                {formatDateTime(cell?.value)}
                            </TableCell>
                        );
                    }
                    case "CURRENCY": {
                        return (
                            <TableCell key={_.uniqueId(cell.id)}>
                                {getCurrencyFormat(cell?.value)}
                            </TableCell>
                        );
                    }
                    case "STATUS": {
                        return (
                            <TableCell key={_.uniqueId(cell.id)}>
                                {formatStatus(cell?.value) ?? "-"}
                            </TableCell>
                        );
                    }
                    case "PRE_SIGNED_URL": {
                        return (
                            <TableCell key={_.uniqueId(cell.id)}>
                                <Link
                                    onClick={async () =>
                                        await Storage.get(cell?.s3Prefix + cell?.value, {
                                            //TODO:
                                            download: true,
                                            expires: 60,
                                            cacheControl: "no-cache",
                                        }).then(result => {
                                            downloadBlob(result.Body, cell?.value);
                                        })
                                    }
                                    type="secondary"
                                    href={cell?.value}
                                >
                                    {cell?.value}
                                </Link>
                            </TableCell>
                        );
                    }
                    default: {
                        return <TableCell key={_.uniqueId(cell.id)}>{cell?.value}</TableCell>;
                    }
                }
            })}
        </React.Fragment>
    );
};
